import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const ProviderName = ({
  selectedCallProvider
}) => {
  return /*#__PURE__*/_jsx(View, {
    paddingInline: "400",
    paddingBlockStart: "300",
    paddingBlockEnd: "200",
    children: /*#__PURE__*/_jsx(Text, {
      typography: "heading-50",
      children: selectedCallProvider.name
    })
  });
};
export default ProviderName;